'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var vastBaseStyle = exports.vastBaseStyle = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  backgroundColor: 'transparent'
};
//# sourceMappingURL=styles.js.map


// WEBPACK FOOTER //
// ./src/helpers/styles.js